import { observer } from 'mobx-react-lite'
import { useRef, useState } from 'react'
import { nanoid } from 'nanoid'
import { PlayBtn } from 'shared/ui/Button/ui/PlayBtn/PlayBtn'
import { secondsToTime } from 'shared/lib/secondsToTime'
import { Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { AudioWave } from 'shared/ui/AudioPlayer'
import type { IUseWaveformApiRef } from 'shared/ui/AudioPlayer/ui/AudioWave/hooks/useWaveformApiRef.ts'
import styles from 'widgets/Record/ui/RecordActions/RecordPlayer/styles.module.scss'
import { type RecordStore } from 'widgets/Record'

export const AudioContent = observer(({ recordStore }: { recordStore: RecordStore }) => {
  const { src, mediaControllerStore } = recordStore
  const { isPlay, currentTime, duration, setDuration } = mediaControllerStore
  const [playing, setPlaying] = useState(false)
  const [id] = useState(() => nanoid(12))
  const waveformRef = useRef<IUseWaveformApiRef | null>(null)

  const onPlay = () => {
    uiStore.setPlayAudioId(id)

    waveformRef.current?.onWaveformPlay({
      playing: playing,
      onFinish: () => {
        setPlaying(!playing)
      },
    })
  }

  return (
    <>
      <PlayBtn
        isPlay={playing}
        togglePlay={onPlay}
        color={'primary'}
        transparentBackground
        size={'small'}
        fontSize={20}
        className={styles.playBtn}
      />
      <AudioWave
        ref={waveformRef}
        url={src}
        setDuration={setDuration}
        setPlaying={setPlaying}
        playing={playing}
        id={id}
      />
      <Typography
        variant={'body-md-regular'}
        className={styles.time}
        tag={'div'}
        ariaLabel={'time'}
      >
        {secondsToTime(isPlay ? currentTime : currentTime || duration)}
      </Typography>
    </>
  )
})
